module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-300.woff2?e8794816c5eaeaa9dd20a6d77ea3b272";